// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as ShareComponent} from './Share.svg';

import Icon, { TIconProps } from '../Icon';

export const IconShare = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <ShareComponent/>
  </Icon>
));
